export default __webpack_public_path__ + "static/Activities-b0bce1546b5403e88bfd37bf3a9132d5.png";